import { jsx as _jsx } from "react/jsx-runtime";
import { CheckIcon, InformationCircleIcon, ExclamationIcon, BanIcon, } from "@heroicons/react/outline";
var generalIconStyle = "h-6 w-6 text-white";
var notificationTypeIcons = {
    Info: _jsx(InformationCircleIcon, { className: generalIconStyle }),
    Error: _jsx(BanIcon, { className: generalIconStyle }),
    Warning: _jsx(ExclamationIcon, { className: generalIconStyle }),
    Success: _jsx(CheckIcon, { className: generalIconStyle }),
};
export var NotificationTypeIcon = function (_a) {
    var type = _a.type;
    return notificationTypeIcons[type];
};
